    <form #partForm="ngForm">
      <div class="row top10">
      <aims-form
        [editable]="true"
        [cols]="1"
        [spaceRows]="true" >

        <div style="margin-left: 30px; margin-bottom: 20px;"><i>Lookup Item OR Enter Item Number</i></div>

        <aims-fc [labelColSize]="2" [controlColSize]="3">
          <aims-lookup #aimsControl="ngModel"
            class="fullWidth"
            name="Lookup Item"
            [(ngModel)]="inventoryBarcodeToAdd"
            [gridText]="'Select an Item'"
            id="inventoryItemLookup"
            [values]="inventory | async"
            [idPropertyName]="'barcode'"
            [displayPropertyName]="'barcode'"
            [columnsInGrid]="itemLookupColumns"
            (valueChange)="handleItemLookupChange($event)"
            >
          </aims-lookup>
        </aims-fc>

        <aims-fc [labelColSize]="2" [controlColSize]="3">
          <mat-form-field>
          <input
            matInput
            autocomplete="off"
            type="text"
            #aimsControl="ngModel"
            name="Item #"
            id="inventoryItemBarcode"
            mask="0000000000000000"
            [(ngModel)]="inventoryItem.barcode"
            (input)="onValueChange($event)"
            required >
            </mat-form-field>
        </aims-fc>
      </aims-form>
      </div>

      <aims-form [editable]="false" [cols]="1" [spaceRows]="true">
        <aims-fc [labelColSize]="2" [controlColSize]="6">
          <mat-form-field>
            <input
              matInput
              #aimsControl="ngModel"
              id="description"
              type="text"
              name="Description"
              [(ngModel)]="inventoryItem.description"
              required >
          </mat-form-field>
        </aims-fc>
        <aims-fc [labelColSize]="2" [controlColSize]="1">
          <input
            type="checkbox"
            #aimsControl="ngModel"
            name="Assembly Issued"
            [(ngModel)]="inventoryItem.assemblyIssued"
            tabindex="-1" />
        </aims-fc>
        <aims-fc [labelColSize]="2" [controlColSize]="1">
          <input
            type="checkbox"
            #aimsControl="ngModel"
            name="Work Order Required"
            [(ngModel)]="inventoryItem.workOrderRequired"
            tabindex="-1" />
        </aims-fc>
        <aims-fc [labelColSize]="2" [controlColSize]="3">
          <mat-form-field>
            <input matInput
              #aimsControl="ngModel"
              class="fullWidth"
              id="unitOfMeasure"
              type="text"
              name="Unit of Measure"
              [(ngModel)]="inventoryItem.unitOfIssueId"
              required />
          </mat-form-field>
        </aims-fc>

        <aims-fc [labelColSize]="2" [controlColSize]="3">
          <mat-form-field>
            <input matInput
              type="text"
              #aimsControl="ngModel"
              name="Quantity On-Hand"
              id="quantityoh"
              [(ngModel)]="quantityOnHand"
            />
          </mat-form-field>
        </aims-fc>
      </aims-form>

      <aims-form
        [editable]="inventoryItem.inventoryItemId != 0 && !inventoryItem.assemblyIssued"
        [cols]="1"
        [spaceRows]="true" >
        <aims-fc [labelColSize]="2" [controlColSize]="3">

          <mat-form-field>
            <input matInput
              #quantity
              #aimsControl="ngModel"
              name="Quantity Wanted"
              id="quantity"
              [min]="1"
              [max]="100000"
              type="number"
              [(ngModel)]="partQuantity"
              required
            />
          </mat-form-field>

        </aims-fc>
      </aims-form>
      <aims-form [editable]="false" [cols]="1" [spaceRows]="true">
        <aims-fc [labelColSize]="3" [controlColSize]="3">
          <aims-common-button
            title="Add Inventory"
            aria-label="Add Inventory"
            [disabled]="inventoryItem.inventoryItemId == 0 || partQuantity == 0 ||(!IsWorkOrder && inventoryItem.workOrderRequired)"
            (click)="addItem()">
            <mat-icon color="primary">playlist_add</mat-icon>
          </aims-common-button>

          <ng-container *ngIf="!IsWorkOrder && inventoryItem.workOrderRequired">
            <span class="warningmessage" > Item can only be added to a Work Order </span>
          </ng-container>

        </aims-fc>
      </aims-form>
    </form>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner" ></aims-spinner>
